import { Badge, Box, BoxProps, Center } from "@chakra-ui/react";
import BoldSpinner from "components/BoldSpinner";
import SelectionIndicator from "components/SelectionIndicator";
import V1Image from "components/V1Image";

export type V1CardProps = BoxProps & {
  tokenId: number;
  isSelected?: boolean;
  isBusy?: boolean;
  isDisabled?: boolean;
  badgeText?: string;
  withV2Badge?: boolean;
  onClick?: (tokenId: number) => void;
};

const V1Card: React.FC<V1CardProps> = ({
  tokenId,
  badgeText,
  isDisabled = false,
  isSelected = false,
  isBusy = false,
  withV2Badge = false,
  bg = "dark.700",
  children,
  onClick,
  ...rest
}) => {
  return (
    <Box
      bg={bg}
      p="1.5"
      w="full"
      outline="2px solid"
      userSelect="none"
      outlineColor={isSelected ? "bright.50" : "transparent"}
      cursor={isDisabled ? "not-allowed" : onClick ? "pointer" : "default"}
      transition="all 0.15s"
      borderRadius="lg"
      overflow="hidden"
      tabIndex={0}
      onClick={() => {
        if (!isDisabled && onClick) {
          onClick(tokenId);
        }
      }}
      {...rest}
    >
      <Box position="relative">
        <V1Image
          tokenId={tokenId}
          isDisabled={isDisabled || isBusy}
          withV2Badge={withV2Badge}
        />

        <SelectionIndicator
          position="absolute"
          bg={bg}
          color="bright.50"
          top="-1.5"
          left="-1.5"
          isSelected={isSelected}
        />

        <Center
          position="absolute"
          top="-2"
          right="-2"
          bg="bright.500"
          w="10"
          h="10"
          zIndex="dropdown"
          opacity={isBusy ? "1" : "0"}
          transition="opacity 0.15s"
        >
          {isBusy && <BoldSpinner size="sm" thickness="3px" />}
        </Center>

        {badgeText && (
          <Badge
            position="absolute"
            top="50%"
            left="50%"
            bg="dark.900"
            color="bright.50"
            px="4"
            py="2"
            transform="translate(-50%, -50%)"
          >
            {badgeText}
          </Badge>
        )}
      </Box>

      <Box>{children}</Box>
    </Box>
  );
};

export default V1Card;
